<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Score</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/forms/' + patient.id"
      no-data-label="Nenhum score cadastrado"
      no-result-label="Nenhum score encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <span @click="openModal(row)"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></span>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <span @click="openModal(row)"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></span>
        </div>
      </template>
    </data-table>
    <modal ref="modal" size="modal-lg" :modal-scrollable="true">
      <template #header>
          <div class="text-gray-777 font-roboto uppercase">
              <span>{{ $filters.formatDateTime(selectedItem.date) }} - {{ selectedItem.form.name }} <span v-if="selectedItem.score"> - {{ selectedItem.score }}</span></span>
          </div>
      </template>
      <template #body>
        <div class="mb-2 pb-2 border-b" v-for="(question, index) in selectedItem.questions">
          <div class="font-bold">{{ question.question.order }} - {{ question.question.question }}</div>
          <div v-if="question.form_question_answer && (question.question.type == 'caixa_selecao' || question.question.type == 'multipla_escolha')">
            <div v-for="(answer, index) in question.form_question_answer">
              {{ answer.answer }} - <span class="font-bold">Score:</span> {{ answer.score }}
            </div>
          </div>
          <div v-else>{{ question.answer }}</div>
        </div>
      </template>
      <template #footer>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModal">Fechar</button>
      </template>
    </modal>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal'
import DataTable from '@/Shared/DataTable'

export default {
  inject: ['patient'],
  components: {
    Modal,
    DataTable,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user);
    return {
      user,
    }
  },
  data() {
    return {
      selectedItem: Object,
      loadTable: true,
      columns: [
        {
          uniqid: 'form_date',
          label: 'Data',
          field: 'date',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDateTime(row.date),
        },
        {
          uniqid: 'form_score',
          label: 'Score',
          field: 'score',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left'
        },
        {
          uniqid: 'form_name',
          label: 'Formulário',
          field: 'forms.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.form.name ? row.form.name : ''
        },
        {
          uniqid: 'form_description',
          label: 'Descrição',
          field: 'forms.description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.form.description ? row.form.description.substr(0, 50) : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModal(item) {
      item.questions.sort((a, b) => (a.question.order > b.question.order ? 1 : (a.question.order < b.question.order ? -1 : 0)))
      this.selectedItem = item;
      this.$refs.modal.showModal = true;
    },
    closeModal() {
      this.$refs.modal.showModal = false;
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>